import { patch } from "@src/appV2/api/api";
import { API_TYPES } from "@src/appV2/api/constants";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { z } from "zod";

const PATCH_WORKPLACE_PLACEMENT_SETTINGS_API_URL = `${environmentConfig.REACT_APP_BASE_API_URL}/workplaces/features/placements`;

const patchWorkplacePlacementSettingsRequestSchema = z.object({
  data: z.array(
    z
      .object({
        type: z.literal(API_TYPES.workplace),
        id: z.string(),
        attributes: z.object({
          managedByParentWorkplace: z.boolean(),
        }),
      })
      .strict()
  ),
});
type PatchWorkplacePlacementSettingsRequest = z.infer<
  typeof patchWorkplacePlacementSettingsRequestSchema
>;

const patchWorkplacePlacementSettingsResponseSchema = z.object({
  data: z.array(
    z.object({
      type: z.literal(API_TYPES.workplace),
      id: z.string(),
      attributes: z.object({
        managedByParentWorkplace: z.boolean(),
      }),
    })
  ),
});
type PatchWorkplacePlacementSettingsResponse = z.infer<
  typeof patchWorkplacePlacementSettingsResponseSchema
>;

export function useUpdateWorkplacePlacementSettings(
  options: UseMutationOptions<
    PatchWorkplacePlacementSettingsResponse,
    unknown,
    PatchWorkplacePlacementSettingsRequest
  > = {}
) {
  return useMutation({
    ...options,
    mutationFn: async (data: PatchWorkplacePlacementSettingsRequest) => {
      const response = await patch({
        url: PATCH_WORKPLACE_PLACEMENT_SETTINGS_API_URL,
        requestSchema: patchWorkplacePlacementSettingsRequestSchema,
        responseSchema: patchWorkplacePlacementSettingsResponseSchema,
        data,
      });

      return response.data;
    },
  });
}
